module.exports = __webpack_public_path__ + "img/优惠券.2c61c2ad.png";